





























import { Product, SearchProductOptions } from '@/models'
import ApiClient from '@/services/api-client'
import { Component, Vue } from 'vue-property-decorator'

const CODE_RE = /(^|[^A-Za-z0-9])(?:[A-Za-z]{2})?(\d{6}[A-Za-z]?)(?![A-Za-z0-9])/gi

@Component
export default class ProductSearchHeader extends Vue {
  private productSearch: Product | null = null
  private productSearchArray: Product[] = []

  private onSearchProduct(search: string, loading: any) {
    if (search.length > 2) {
      this.searchProducts(search, loading)
    }
  }

  private searchProducts(search: string, loading: any) {
    const searchExtract = this.extractFirstCode(search)
    if (searchExtract) {
      search = searchExtract
    }

    loading(true)
    const searchOptions: SearchProductOptions = {
      search: search,
      offset: 0,
      limit: 10,
      educationLevel1: null,
      manager: null,
      type: null,
      country: null,
      workType: null,
      subject: null,
      productionCampaign: null,
      editorialProject: null,
      relatedToDigital: null,
      editorialProjectYearStart: null,
      language: null,
      educationLevel2: null
    }

    ApiClient.searchProducts(searchOptions)
      .then(async(result) => {
        this.productSearchArray = result.items
        loading(false)
      })
      .catch((e) => {
        loading(false)
        console.error('Error loading products', e)
      })
  }

  private productSearchSelect() {
    if (!this.productSearch) {
      return null
    }

    const code = this.productSearch.code
    this.productSearch = null
    this.productSearchArray = []
    this.$router.push('/product/' + code)
  }

  private extractFirstCode(text: string): string | null {
    const re = new RegExp(CODE_RE)
    const m = re.exec(text)
    return m ? m[2] : null
  }
}
